<template>
  <div class="lg:flex lg:flex-wrap shadow-lg p-2 mb-7 border">
    <div class="flex items-center justify-center lg:w-1/3">
      <Image
          :src="`/static/images/alumni/${stories.img}.jpg`"
          alt="Alumni image"/>
    </div>
    <div class="py-2 px-4 flex-1 flex flex-col  gap-1">
      <h2 class="text-xl text-gray-800 font-bold pb-2">{{ stories.name }}</h2>
      <h3 class="text-xl text-gray-700 font-bold pb-2">{{ stories.position }}</h3>
      <p class="text-gray-600 font-semibold text-justify max-h-min">{{ stories.details }}</p>
    </div>
  </div>
</template>

<script>
import Image from 'primevue/image';

export default {
  name: "SuccessStory",
  components: {
    Image
  },
  props: {
    stories: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style scoped>

</style>
